import { render, staticRenderFns } from "./b31.vue?vue&type=template&id=791f2e04&scoped=true"
import script from "./b31.vue?vue&type=script&lang=js"
export * from "./b31.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791f2e04",
  null
  
)

export default component.exports